import { apiClient } from "./axios";
import { RoleResponse } from "./role";

export interface ProfileResponse {
    id: string;
    name: string;
    email: string;
    phoneNumber: string;
    dateOfBirth: string;
    address: string;
    role: RoleResponse  
}

export const getProfile = async (): Promise<ProfileResponse> => {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await apiClient.get<ProfileResponse>('auth/me');
    return response.data;
  } catch (error) {
    throw error;
  }
};